import isInViewport from 'utils/IsInViewport'
import ScrollUtils from 'utils/scrollUtils'
import { mapState } from 'vuex'
import 'mdn-polyfills/Element.prototype.closest'

const formHelpers = {
  computed: {
    ...mapState({
      $_formHelpers_deviceType: (state) => state.device.deviceType
    })
  },

  methods: {
    getTargetScrollYPos(target) {
      const headerElement = document.querySelector('.header-wrap-white')
      const headerHeight =  headerElement? headerElement?.offsetHeight : 50

      const errorElementPosition = target.getBoundingClientRect()
      const scroll = errorElementPosition.top + window.scrollY

      return (scroll - headerHeight - 20) || 0
    },
    $_formHelpers_scrollToError(element, options) {
      const error = element.querySelector(options.errorElement)
      let firstError

      if (!error) {
        return
      }

      if (options.parents) {
        options.parents.some((item) => {
          if (error.closest(item)) {
            firstError = error.closest(item)
          }
        })
      }

      firstError = firstError ? firstError : error

      if (firstError && !isInViewport(firstError)) {
        ScrollUtils.smoothScroll(this.getTargetScrollYPos(firstError), 300)
      }
    },

    $_formHelpers_scrollToErrorIeFriendly(component, errorClass, parents) {
      const error = component.getElementsByClassName(errorClass)[0]
      let firstError

      if (!error) {
        return
      }

      if (parents) {
        parents.some((item) => {
          if (error.closest(item)) {
            firstError = error.closest(item)
          }
        })
      }

      firstError = firstError ? firstError : error

      if (firstError && !isInViewport(firstError)) {
        ScrollUtils.smoothScroll(this.getTargetScrollYPos(firstError), 300)
      }
    }
  }
}

export default formHelpers
